// Sprint 2D-PART-A: tassonomie categorie multi-livello.
// Centralized so multiple components share the same source of truth.
export const CATEGORIE_LABELS = {
  utenti_interni: "Utenti interni",
  base: "Base",
  fornitore_veicoli: "Fornitore veicoli",
  fornitore_servizi_veicoli: "Fornitore servizi veicoli",
  fornitore_servizi_ripristino: "Fornitore servizi ripristino",
  fornitore_servizi_vari: "Fornitore servizi vari",
  fornitore_servizi_finanziari: "Fornitore servizi finanziari",
};

export const CATEGORIE_KEYS = Object.keys(CATEGORIE_LABELS);

export const TIPO_PERSONA_LABELS = {
  privato: "Privato",
  azienda: "Azienda",
  pubblica_amministrazione: "Pubblica Amministrazione",
};

export const SUB_LABELS = {
  // utenti_interni
  admin: "Admin",
  venditore_interno: "Venditore interno",
  segreteria: "Segreteria",
  tecnico: "Tecnico",
  // base
  lead: "Lead",
  cliente: "Cliente",
  contatto: "Contatto",
  // fornitore_veicoli
  occasionale: "Occasionale",
  commerciante: "Commerciante",
  importatore: "Importatore",
  concessionario: "Concessionario",
  // fornitore_servizi_veicoli
  agenzia_disbrigo: "Agenzia disbrigo",
  trasporto_veicoli: "Trasporto veicoli",
  gommista_b2b: "Gommista B2B",
  // fornitore_servizi_ripristino
  meccanico: "Meccanico",
  gommista: "Gommista",
  carrozzeria: "Carrozzeria",
  elettrauto: "Elettrauto",
  // fornitore_servizi_finanziari
  assicurazione: "Assicurazione",
  finanziaria: "Finanziaria",
  banca: "Banca",
  // generici
  altro: "Altro",
};

export function summarizeCategorie(categorie) {
  if (!categorie) return [];
  const out = [];
  for (const key of CATEGORIE_KEYS) {
    const arr = categorie[key] || [];
    for (const v of arr) {
      out.push({ key, value: v, label: SUB_LABELS[v] || v, group: CATEGORIE_LABELS[key] });
    }
  }
  return out;
}

export function isEmptyCategorie(categorie) {
  if (!categorie) return true;
  return CATEGORIE_KEYS.every((k) => (categorie[k] || []).length === 0);
}

export function emptyCategorie() {
  return CATEGORIE_KEYS.reduce((acc, k) => { acc[k] = []; return acc; }, {});
}
